import angular from "angular";
import template from "./school-create-zone.html";
import AdminSchoolZoneCreateController from "./school-create-zone.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.zones.create", {
    url: "/:schoolId/create",
    controller: AdminSchoolZoneCreateController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.zones.create", [])
  .config(config)
  .controller(
    "AdminSchoolZoneCreateController",
    AdminSchoolZoneCreateController,
  );
